import React, { useState } from 'react';
import Footer from '../components/Footer';

const ContactPage: React.FC = () => {
  const [formData, setFormData] = useState({
    name: '',
    email: '',
    phone: '',
    subject: 'general',
    message: ''
  });

  const [submitted, setSubmitted] = useState(false);

  const handleSubmit = (e: React.FormEvent) => {
    e.preventDefault();
    // TODO: Implement form submission logic
    console.log('Form submitted:', formData);
    setSubmitted(true);
    
    // Reset form after 3 seconds
    setTimeout(() => {
      setSubmitted(false);
      setFormData({
        name: '',
        email: '',
        phone: '',
        subject: 'general',
        message: ''
      });
    }, 3000);
  };

  const handleChange = (e: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement | HTMLSelectElement>) => {
    setFormData({
      ...formData,
      [e.target.name]: e.target.value
    });
  };

  return (
    <div className="contact-page">
      {/* Hero Section */}
      <section className="contact-hero">
        <div className="container">
          <h1>Contact Alert1</h1>
          <p className="hero-subtitle">
            We're here to answer your questions and help you choose the right medical alert system
          </p>
        </div>
      </section>

      {/* Contact Methods */}
      <section className="contact-methods-section">
        <div className="container">
          <div className="contact-methods-grid">
            {/* Phone */}
            <div className="contact-method-card">
              <div className="method-icon">
                <svg width="48" height="48" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                  <path d="M22 16.92v3a2 2 0 0 1-2.18 2 19.79 19.79 0 0 1-8.63-3.07 19.5 19.5 0 0 1-6-6 19.79 19.79 0 0 1-3.07-8.67A2 2 0 0 1 4.11 2h3a2 2 0 0 1 2 1.72 12.84 12.84 0 0 0 .7 2.81 2 2 0 0 1-.45 2.11L8.09 9.91a16 16 0 0 0 6 6l1.27-1.27a2 2 0 0 1 2.11-.45 12.84 12.84 0 0 0 2.81.7A2 2 0 0 1 22 16.92z"/>
                </svg>
              </div>
              <h3>Call Us</h3>
              <div className="method-details">
                <p className="method-primary"><strong>Sales:</strong></p>
                <p><a href="tel:1-877-579-9862" className="contact-phone">1-877-579-9862</a> ext 1</p>
                <p className="hours">Mon-Fri: 9 AM - 8 PM ET<br />Sat: 9 AM - 5:30 PM ET</p>
                
                <p className="method-primary"><strong>Member Care:</strong></p>
                <p><a href="tel:1-877-579-9862" className="contact-phone">1-877-579-9862</a> ext 2</p>
                <p className="hours">Mon-Fri: 9 AM - 5:30 PM ET</p>
                
                <p className="method-primary"><strong>Technical Support:</strong></p>
                <p><a href="tel:1-877-579-9862" className="contact-phone">1-877-579-9862</a> ext 3</p>
                <p className="hours">Mon-Fri: 9 AM - 5:30 PM ET</p>
              </div>
            </div>

            {/* Email */}
            <div className="contact-method-card">
              <div className="method-icon">
                <svg width="48" height="48" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                  <path d="M4 4h16c1.1 0 2 .9 2 2v12c0 1.1-.9 2-2 2H4c-1.1 0-2-.9-2-2V6c0-1.1.9-2 2-2z"/>
                  <polyline points="22,6 12,13 2,6"/>
                </svg>
              </div>
              <h3>Email Us</h3>
              <div className="method-details">
                <p className="method-primary"><strong>General Inquiries:</strong></p>
                <p><a href="mailto:info@alert-1.com">info@alert-1.com</a></p>
                
                <p className="method-primary"><strong>Support:</strong></p>
                <p><a href="mailto:support@alert-1.com">support@alert-1.com</a></p>
                
                <p className="method-primary"><strong>Sales:</strong></p>
                <p><a href="mailto:sales@alert-1.com">sales@alert-1.com</a></p>
                
                <p className="response-time">We typically respond within 24 hours</p>
              </div>
            </div>

            {/* Live Chat */}
            <div className="contact-method-card">
              <div className="method-icon">
                <svg width="48" height="48" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                  <path d="M21 15a2 2 0 0 1-2 2H7l-4 4V5a2 2 0 0 1 2-2h14a2 2 0 0 1 2 2z"/>
                </svg>
              </div>
              <h3>Live Chat</h3>
              <div className="method-details">
                <p>Chat with our team in real-time for quick answers to your questions.</p>
                <button className="btn-chat" disabled>
                  Start Chat
                  <span className="chat-status">(Coming Soon)</span>
                </button>
                <p className="hours">Available Mon-Fri: 9 AM - 5:30 PM ET</p>
              </div>
            </div>

            {/* Mailing Address */}
            <div className="contact-method-card">
              <div className="method-icon">
                <svg width="48" height="48" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                  <path d="M21 10c0 7-9 13-9 13s-9-6-9-13a9 9 0 0 1 18 0z"/>
                  <circle cx="12" cy="10" r="3"/>
                </svg>
              </div>
              <h3>Mailing Address</h3>
              <div className="method-details">
                <p><strong>AlertOne Services, LLC</strong></p>
                <p>1000 Commerce Park Dr #300</p>
                <p>Williamsport, PA 17701</p>
                <p style={{ margin: '0.5rem 0', fontWeight: 'bold' }}>OR</p>
                <p>3411 Hawthorne Rd</p>
                <p>Pocatello, ID 83201</p>
                <p className="note">For returns and written correspondence</p>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Contact Form */}
      <section className="contact-form-section">
        <div className="container">
          <div className="form-layout">
            <div className="form-intro">
              <h2>Send Us a Message</h2>
              <p>
                Fill out the form below and we'll get back to you as soon as possible. 
                For urgent matters, please call us directly.
              </p>
            </div>

            <div className="form-container">
              {submitted ? (
                <div className="form-success">
                  <div className="success-icon">✓</div>
                  <h3>Thank You!</h3>
                  <p>Your message has been sent successfully. We'll be in touch soon!</p>
                </div>
              ) : (
                <form onSubmit={handleSubmit} className="contact-form">
                  <div className="form-row">
                    <div className="form-group">
                      <label htmlFor="name">Your Name *</label>
                      <input
                        type="text"
                        id="name"
                        name="name"
                        value={formData.name}
                        onChange={handleChange}
                        required
                        placeholder="John Smith"
                      />
                    </div>

                    <div className="form-group">
                      <label htmlFor="email">Email Address *</label>
                      <input
                        type="email"
                        id="email"
                        name="email"
                        value={formData.email}
                        onChange={handleChange}
                        required
                        placeholder="john@example.com"
                      />
                    </div>
                  </div>

                  <div className="form-row">
                    <div className="form-group">
                      <label htmlFor="phone">Phone Number</label>
                      <input
                        type="tel"
                        id="phone"
                        name="phone"
                        value={formData.phone}
                        onChange={handleChange}
                        placeholder="(555) 123-4567"
                      />
                    </div>

                    <div className="form-group">
                      <label htmlFor="subject">Subject *</label>
                      <select
                        id="subject"
                        name="subject"
                        value={formData.subject}
                        onChange={handleChange}
                        required
                      >
                        <option value="general">General Inquiry</option>
                        <option value="sales">Sales Question</option>
                        <option value="support">Technical Support</option>
                        <option value="billing">Billing Question</option>
                        <option value="partnership">Partnership Opportunity</option>
                        <option value="other">Other</option>
                      </select>
                    </div>
                  </div>

                  <div className="form-group">
                    <label htmlFor="message">Your Message *</label>
                    <textarea
                      id="message"
                      name="message"
                      value={formData.message}
                      onChange={handleChange}
                      required
                      rows={6}
                      placeholder="How can we help you?"
                    />
                  </div>

                  <div className="form-actions">
                    <button type="submit" className="btn btn-primary">
                      Send Message
                    </button>
                    <p className="form-note">
                      * Required fields. We'll never share your information with third parties.
                    </p>
                  </div>
                </form>
              )}
            </div>
          </div>
        </div>
      </section>

      {/* FAQ Quick Links */}
      <section className="contact-faq-section">
        <div className="container">
          <h2>Quick Answers</h2>
          <p>Looking for immediate answers? Check out these popular topics:</p>
          
          <div className="faq-quick-links">
            <a href="/faq" className="faq-quick-link">
              <span className="link-icon">❓</span>
              <span className="link-text">Frequently Asked Questions</span>
            </a>
            <a href="/pricing" className="faq-quick-link">
              <span className="link-icon">💰</span>
              <span className="link-text">Pricing & Plans</span>
            </a>
            <a href="/how-it-works" className="faq-quick-link">
              <span className="link-icon">⚙️</span>
              <span className="link-text">How It Works</span>
            </a>
            <a href="/where-it-works" className="faq-quick-link">
              <span className="link-icon">📍</span>
              <span className="link-text">Coverage Areas</span>
            </a>
          </div>
        </div>
      </section>

      {/* Emergency Note */}
      <section className="emergency-note-section">
        <div className="container">
          <div className="emergency-note">
            <div className="note-icon">🚨</div>
            <div className="note-content">
              <h3>In Case of Emergency</h3>
              <p>
                If you are experiencing a medical emergency, <strong>call 911 immediately</strong>. 
                This contact form is for general inquiries only and is not monitored 24/7.
              </p>
            </div>
          </div>
        </div>
      </section>

      <Footer />
    </div>
  );
};

export default ContactPage;


